module.exports = __webpack_public_path__ + "img/side_zipper_length.fdaa35b4.png";